import React, { useEffect, useRef, useState } from 'react';

const VideoPlayer = ({ bannerLarge, src }) => {
	const videoRef = useRef(null);
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		const video = videoRef.current;
		if (!video) return;

		// Intersection Observer to lazy load and play video when in viewport
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					// Load & play video when visible
					video.load();
					video.play().catch(() => {
						// play might fail if user hasn't interacted yet
					});
					setIsLoaded(true);
					observer.disconnect();
				}
			},
			{
				rootMargin: '200px', // preload a bit before fully visible
				threshold: 0.1,
			}
		);

		observer.observe(video);

		return () => observer.disconnect();
	}, []);

	return (
		<video
			ref={videoRef}
			poster={bannerLarge}
			src={bannerLarge ? bannerLarge : src ? src : '/images/video.mp4'}
			autoPlay={isLoaded}
			muted
			loop
			playsInline
			preload="auto"
			// optionally you can add controls if you want user interaction
		/>
	);
};

export default VideoPlayer;
